import { instanciaActual } from '@/lib/instancia';

/**
 * Identidad del sitio en producción: la marca BET SUPPLIER y el pie de Coopen.
 *
 * Sólo en la instancia de PRODUCCIÓN, a propósito. Hasta el 2026-09-18 los dos
 * despliegues eran idénticos y no había forma de saber en cuál se estaba; si la
 * marca apareciera en los dos, volverían a serlo. La vieja se identifica por su
 * cartel de mudanza (`AvisoInstancia`); la nueva, por esto.
 */

/** La palabra BET SUPPLIER, con link al sitio de la empresa. */
export function MarcaBetLink({ className = '' }: { className?: string }) {
  return (
    <a
      href="https://betsupplier.co/"
      target="_blank"
      rel="noopener noreferrer"
      className={
        'inline-flex items-center py-2 text-sm font-extrabold tracking-[0.2em] ' +
        'transition-opacity duration-150 hover:opacity-80 ' + className
      }
    >
      BET <span className="ml-[0.4em] text-primary">SUPPLIER</span>
    </a>
  );
}

export function PieCoopen({ className = '' }: { className?: string }) {
  if (!instanciaActual().esProduccion) return null;
  return (
    <footer className={'w-full py-5 text-center text-xs text-slate-500 ' + className}>
      Powered by{' '}
      <a
        href="https://coopenstudio.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold text-slate-700 underline-offset-4 transition-colors duration-150 hover:text-amber-700 hover:underline"
      >
        Coopen Studio
      </a>
    </footer>
  );
}
